import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const useStore = create(
  devtools(
    (set, get) => ({
      // User state
      user: null,
      isAuthenticated: false,
      
      // UI state
      sidebarCollapsed: false,
      themeMode: 'light', // 'light' | 'dark'
      
      // Data
      products: [],
      categories: [],
      locations: [],
      customers: [],
      orders: [],
      quotes: [],
      purchaseOrders: [],
      vendors: [],
      receivingRecords: [],
      ewayBills: [],
      dashboardData: null,
      
      // Actions
      setUser: (user) => set({ user, isAuthenticated: !!user }),
      logout: () => set({ user: null, isAuthenticated: false }),
      toggleSidebar: () => set((state) => ({ sidebarCollapsed: !state.sidebarCollapsed })),
      setThemeMode: (mode) => set({ themeMode: mode }),
      toggleTheme: () => set((state) => ({ themeMode: state.themeMode === 'light' ? 'dark' : 'light' })),
      
      // Data setters
      setProducts: (products) => set({ products }),
      setCategories: (categories) => set({ categories }),
      setLocations: (locations) => set({ locations }),
      setCustomers: (customers) => set({ customers }),
      setOrders: (orders) => set({ orders }),
      setQuotes: (quotes) => set({ quotes }),
      setPurchaseOrders: (purchaseOrders) => set({ purchaseOrders }),
      setVendors: (vendors) => set({ vendors }),
      setReceivingRecords: (receivingRecords) => set({ receivingRecords }),
      setEwayBills: (ewayBills) => set({ ewayBills }),
      setDashboardData: (dashboardData) => set({ dashboardData }),
      
      addProduct: (product) => set((state) => ({ 
        products: [...state.products, product] 
      })),
      updateProduct: (id, updates) => set((state) => ({
        products: state.products.map(p => p.id === id ? { ...p, ...updates } : p)
      })),
      deleteProduct: (id) => set((state) => ({
        products: state.products.filter(p => p.id !== id)
      })),
      
      addCategory: (category) => set((state) => ({ 
        categories: [...state.categories, category] 
      })),
      
      addLocation: (location) => set((state) => ({ 
        locations: [...state.locations, location] 
      })),
      
      addVendor: (vendor) => set((state) => ({ 
        vendors: [...state.vendors, vendor] 
      })),
      
      addCustomer: (customer) => set((state) => ({ 
        customers: [...state.customers, customer] 
      })),
      
      addOrder: (order) => set((state) => ({ 
        orders: [...state.orders, order] 
      })),
      addEwayBill: (bill) => set((state) => ({
        ewayBills: [...state.ewayBills, bill]
      })),
      updateOrder: (id, updates) => set((state) => ({
        orders: state.orders.map(o => o.id === id ? { ...o, ...updates } : o)
      })),
      
      // Computed getters
      getLowStockProducts: () => {
        const { products } = get();
        return products.filter(product => 
          product.currentStock <= product.reorderPoint
        );
      },
      
      getPendingOrders: () => {
        const { orders } = get();
        return orders.filter(order => 
          order.status === 'pending' || order.status === 'processing'
        );
      },
    }),
    {
      name: 'inventory-store',
    }
  )
);

export default useStore;
